import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c7b2c2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pagination" }

import { ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Pagination',
  props: {
    currentPage: {},
    pageSize: {},
    totalSize: {}
  },
  emits: ["update:currentPage", "update:pageSize"],
  setup(__props: any, { emit: __emit }) {

const props = __props

// eslint-disable-next-line func-call-spacing
const emit = __emit

const localCurrentPage = ref(props.currentPage)
const localPageSize = ref(props.pageSize)

watch(() => props.currentPage, (newPage) => {
  localCurrentPage.value = newPage
})

watch(() => props.pageSize, (newSize) => {
  localPageSize.value = newSize
})

const onCurrentChange = (page: number) => {
  emit('update:currentPage', page)
}

const onSizeChange = (size: number) => {
  emit('update:pageSize', size)
}

return (_ctx: any,_cache: any) => {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_pagination, {
      "current-page": localCurrentPage.value,
      "page-size": localPageSize.value,
      "hide-on-single-page": true,
      "page-sizes": [12, 24, 36, 48, 60],
      total: _ctx.totalSize,
      layout: "pager",
      "next-text": "下一页",
      "prev-text": "上一页",
      small: "",
      onCurrentChange: onCurrentChange,
      onSizeChange: onSizeChange
    }, null, 8, ["current-page", "page-size", "total"])
  ]))
}
}

})